import React from 'react';
import { theme } from '@app/helpers';

export const PasslyDivider = () => {

    const style = {
        backgroundColor: theme.grayPalette.weight300,
        height: 1,
        border: 'none',
        padding: 0
    };

    return (
        <hr style={style} />
    );
};
